module.exports = __webpack_public_path__ + "static/img/Caketella_logo.4882835.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/Caketella_logo.png
// module id = aRXQ
// module chunks = 0